import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { BASE_URL } from './settings';
import { v4 } from 'uuid';

// 👇️pages
import Home from './pages/Home/Home';
import AdminPage from './pages/Admin/AdminPage';

export default function App() {
    const [alumni, setAlumni] = useState([]);
    const [events, setEvents] = useState([]);
    const [announcements, setAnnouncements] = useState([]);
    const [jobPostings, setJobPostings] = useState([]);
    const [eventsError, setEventsError] = useState('');
    const [announcementsError, setAnnouncementsError] = useState('');
    const [jobPostsError, setJobPostsError] = useState('');
    const [alumniError, setAlumniError] = useState('');

    useEffect(() => {
        fetchEvents();
        fetchAnnouncements();
        fetchJobPosts();
        fetchAllAlumni();
    }, []);

    // 👇️ handler to fetch events from server
    const fetchEvents = async () => {
        fetch(`${BASE_URL}/events`)
            .then(async (result) => {
                let response = await result.json();
                setEvents(response?.all_events || []);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    setEventsError('Could not reach the servers!');
                } else {
                    setEventsError('Could not fetch events!');
                }
            });
    };

    // 👇️ handler to fetch announcements from server
    const fetchAnnouncements = async () => {
        fetch(`${BASE_URL}/announcements`)
            .then(async (result) => {
                let response = await result.json();
                setAnnouncements(response?.all_announcements || []);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    setAnnouncementsError('Could not reach the servers!');
                } else {
                    setAnnouncementsError('Could not fetch announcements!');
                }
            });
    };

    // 👇️ handler to fetch job posts from server
    const fetchJobPosts = async () => {
        fetch(`${BASE_URL}/jobs`)
            .then(async (result) => {
                let response = await result.json();
                setJobPostings(response?.all_jobs_posts || []);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    setJobPostsError('Could not reach the servers!');
                } else {
                    setJobPostsError('Could not fetch job posts!');
                }
            });
    };

    // 👇️ handler to fetch alumni from server
    const fetchAllAlumni = async () => {
        fetch(`${BASE_URL}/alumni/all`)
            .then(async (response) => {
                let data = await response.json();
                let fetched_alumni = data?.all_alumni;
                setAlumni(fetched_alumni || []);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    setAlumniError('Could not reach the servers!');
                } else {
                    setAlumniError('Could not fetch alumni!');
                }
            });
    };

    // 👇️ dummy representatives of photos
    const photos = [
        {
            id: v4(),
            mainUrl: require('./images/home.jpg'),
            thumbnailUrl: require('./images/home.jpg'),
            description: 'Harae Institute of Technology',
        },
        {
            id: v4(),
            mainUrl: require('./images/admin.jpg'),
            thumbnailUrl: require('./images/admin.jpg'),
            description: 'Harare Institute of Technology',
        },
        {
            id: v4(),
            mainUrl: require('./images/img2.jpg'),
            thumbnailUrl: require('./images/img2.jpg'),
            description: 'Harare Institute of Technology',
        },
        {
            id: v4(),
            mainUrl: require('./images/img3.jpg'),
            thumbnailUrl: require('./images/img3.jpg'),
            description: 'Harare Institute of Technology',
        },
        {
            id: v4(),
            mainUrl: require('./images/img1.jpg'),
            thumbnailUrl: require('./images/img1.jpg'),
            description: 'Harare Institute of Technology',
        },
    ];

    return (
        <div className='app'>
            <Router>
                <Routes>
                    <Route
                        exact
                        path='/*'
                        element={
                            <Home
                                events={events}
                                fetchEvents={fetchEvents}
                                announcements={announcements}
                                jobPostings={jobPostings}
                                alumni={alumni}
                                photos={photos}
                                eventsError={eventsError}
                                announcementsError={announcementsError}
                                jobPostsError={jobPostsError}
                                alumniError={alumniError}
                            />
                        }
                    >
                        {' '}
                    </Route>

                    <Route
                        exact
                        path='/admin.console/*'
                        element={
                            <AdminPage
                                alumni={alumni}
                                events={events}
                                announcements={announcements}
                                jobPosts={jobPostings}
                                fetchAllAlumni={fetchAllAlumni}
                                fetchAnnouncements={fetchAnnouncements}
                                fetchJobPosts={fetchJobPosts}
                                fetchEvents={fetchEvents}
                            />
                        }
                    >
                        {' '}
                    </Route>
                </Routes>
            </Router>
        </div>
    );
}
